module.exports = __webpack_public_path__ + "img/sy_5.1229bc3e.png";